import SamlConfigurationForm from "./SamlConfigurationForm";

export default SamlConfigurationForm;
